import { Injectable, Type } from '@angular/core';
import { Observable, forkJoin, map, of } from 'rxjs';
import { ColmecWorkingOrderStepComponent } from '../components/working-order/steps/colmec-working-order-step/colmec-working-order-step.component';
import { ColmecInitWorkingOrderObjectStepComponent } from '../components/working-order/steps/colmec-init-working-order-object-step/colmec-init-working-order-object-step.component';
import { ColmecWorkingOrderBasicInfoStepComponent } from '../components/working-order/steps/colmec-working-order-basic-info-step/colmec-working-order-basic-info-step.component';
import { ColmecWorkingOrderTiresStepComponent } from '../components/working-order/steps/colmec-working-order-tires-step/colmec-working-order-tires-step.component';
import { ColmecWorkingOrderServicesStepComponent } from '../components/working-order/steps/colmec-working-order-services-step/colmec-working-order-services-step.component';
import { ColmecWorkingOrderExtrasStepComponent } from '../components/working-order/steps/colmec-working-order-extras-step/colmec-working-order-extras-step.component';
import { ColmecWorkingOrderSummaryStepComponent } from '../components/working-order/steps/colmec-working-order-summary-step/colmec-working-order-summary-step.component';
import { ColmecWorkOrder } from '../components/working-order/colmec-working-order-wrapper/colmec-working-order-wrapper.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecWorkingOrderConfigService {
  constructor() {}

  getWorkingOrderSteps(): Observable<Type<ColmecWorkingOrderStepComponent>[]> {
    return forkJoin([this.getPreProcessSteps(), this.getMainProcessSteps(), this.getPostProcessSteps()]).pipe(
      map(([pre, main, post]) => [...pre, ...main, ...post])
    );
  }

  getMainProcessSteps(): Observable<Type<ColmecWorkingOrderStepComponent>[]> {
    return of([
      ColmecWorkingOrderBasicInfoStepComponent,
      ColmecWorkingOrderTiresStepComponent,
      ColmecWorkingOrderServicesStepComponent,
      ColmecWorkingOrderExtrasStepComponent,
      ColmecWorkingOrderSummaryStepComponent
    ]);
  }

  getPreProcessSteps(): Observable<Type<ColmecWorkingOrderStepComponent>[]> {
    return of([ColmecInitWorkingOrderObjectStepComponent]);
  }

  getPostProcessSteps(): Observable<Type<ColmecWorkingOrderStepComponent>[]> {
    return of([]);
  }

  getSubmitUrl(workingOrderObject: ColmecWorkOrder = null): Observable<string> {
    return of('json/work-orders');
  }

  getSubmitUrlIgnoreTirePolicy(workingOrderObject: ColmecWorkOrder = null): Observable<string> {
    return of('json/work-orders?ignoreTirePolicy=true');
  }
}
